export default __webpack_public_path__ + "media/images/react_icons/google_outline-ebabe46c0a44771cc5488d42202629a2.svg";